(function () {
  function initFaq(root) {
    if (root.dataset.faqReady === '1') return;
    root.dataset.faqReady = '1';

    root.querySelectorAll('.gh-contact-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.gh-contact-faq__item');
        var open = item.classList.contains('is-open');
        root.querySelectorAll('.gh-contact-faq__item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.gh-contact-faq__q').setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-contact-faq]').forEach(initFaq);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll);
})();
